// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setPassword .setPasswordText {
  width: 288px;
  text-align: left;
  margin: 10px auto;
  color: #262626;
}
.setPassword label {
  display: block;
  position: relative;
  margin-top: 10px;
  font-weight: bold;
  margin: 17px auto 5px auto;
  width: 288px;
  height: 16px;
  font-size: 14px;
  letter-spacing: -0.1px;
  text-align: left;
  color: #262626;
  opacity: 0.65;
}
.setPassword .formLayout.k-form .k-form-field input {
  display: block;
  margin: 0 auto 0 auto;
  padding-left: 10px;
  border: 1px solid #c3cad4;
  width: 288px;
  max-width: 288px;
  height: 36px;
  border-radius: 8px;
  background-color: #f8f7f3;
}
.setPassword .formLayout.k-form .sendButton {
  display: block;
  margin: 20px auto 20px auto;
  width: 134px;
  height: 38px;
  font-weight: bold;
  border-radius: 19px;
  background-color: #19419b;
  border: none;
  font-size: 15px;
  color: #fff;
}
@media (max-width: 599px) {
  .setPassword .setPasswordText {
    width: 300px;
  }
}
.setPassword .resetPassword .fieldset legend {
  font-size: 28px;
}
@media (max-width: 599px) {
  .setPassword .resetPassword .fieldset legend {
    font-size: 21px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/pages/password/SetPassword.less"],"names":[],"mappings":"AAEA;EAEE,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAFF;AAHA;EASE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;AAHF;AAjBA;EAwBE,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAJF;AA5BA;EAoCE,cAAA;EACA,2BAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AALF;AAQC;EAAA;IAEE,YAAA;EAND;AACF;AA7CA;EAwDG,eAAA;AARH;AAWE;EAAA;IAEE,eAAA;EATF;AACF","sourcesContent":["@import (reference) '../../constants.less';\n\n.setPassword {\n\t.setPasswordText {\n\t\twidth: @inputWidth;\n\t\ttext-align: left;\n\t\tmargin: 10px auto;\n\t\tcolor: @lineColor;\n\t}\n\n\tlabel {\n\t\tdisplay: block;\n\t\tposition: relative;\n\t\tmargin-top: 10px;\n\t\tfont-weight: bold;\n\t\tmargin: 17px auto 5px auto;\n\t\twidth: @inputWidth;\n\t\theight: 16px;\n\t\tfont-size: 14px;\n\t\tletter-spacing: -0.1px;\n\t\ttext-align: left;\n\t\tcolor: @labelGrey;\n\t\topacity: 0.65;\n\t}\n\n\t.formLayout.k-form .k-form-field input {\n\t\tdisplay: block;\n\t\tmargin: 0 auto 0 auto;\n\t\tpadding-left: 10px;\n\t\tborder: 1px solid #c3cad4;\n\t\twidth: @inputWidth;\n\t\tmax-width: @inputWidth;\n\t\theight: 36px;\n\t\tborder-radius: 8px;\n\t\tbackground-color: @fieldBackgroundWhite;\n\t}\n\n\t.formLayout.k-form .sendButton {\n\t\tdisplay: block;\n\t\tmargin: 20px auto 20px auto;\n\t\twidth: 134px;\n\t\theight: 38px;\n\t\tfont-weight: bold;\n\t\tborder-radius: 19px;\n\t\tbackground-color: @buttonColor;\n\t\tborder: none;\n\t\tfont-size: 15px;\n\t\tcolor: #fff;\n\t}\n\n\t@media (max-width: @phoneOnlyMaxWidth) {\n\t\t.setPasswordText {\n\t\t\twidth: 300px;\n\t\t}\n\t}\n\n\t.resetPassword {\n\t\t.fieldset legend {\n\t\t\tfont-size: 28px;\n\t\t}\n\n\t\t@media (max-width: @phoneOnlyMaxWidth) {\n\t\t\t.fieldset legend {\n\t\t\t\tfont-size: 21px;\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
